import Vue from "vue";
import VueRouter from "vue-router";
import home from "../views/home.vue";
import aboutUs from "../views/aboutUs/index.vue";
import news from "../views/news/index.vue";
import businessScope from "../views/businessScope/index.vue";
import engineeringCase from "../views/engineeringCase/index.vue";
import contactUs from "../views/contactUs/index.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    component: home,
  },
  {
    path: "/aboutUs",
    name: "aboutUs",
    component: aboutUs,
  },
  {
    path: "/news",
    name: "news",
    component: news,
  },
  {
    path: "/businessScope",
    name: "businessScope",
    component: businessScope,
  },
  {
    path: "/engineeringCase",
    name: "engineeringCase",
    component: engineeringCase,
  },
  {
    path: "/contactUs",
    name: "contactUs",
    component: contactUs,
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
});

router.beforeEach((to, from, next) => {
  next();
});
// 如果目标路径与当前路径相同，则阻止导航

export default router;
